import { Divider } from "@material-ui/core";
import { FC, useState } from "react";
import { FaBarcode } from "react-icons/fa";
import { BOLETO } from "src/constants";
import { FullWidthButton } from "src/framework/components/buttons";
import { BoletoType, PedidoPagamento, PedidoType, TiposPagamentoIDType } from "src/types";
import { Boleto } from "../../boleto/Boleto";
import { HeaderFormaPagamento } from "../HeaderFormaPagamento";
import "./styles.scss"


interface BoletoSoloProperties {
    onIsValid: (isValid: boolean) => void;
    onConfirmar: (pagamento: PedidoPagamento, tipoPagamento: TiposPagamentoIDType) => void;
    pedido: PedidoType | null;
}

const BoletoSolo: FC<BoletoSoloProperties> = ({
    onIsValid,
    onConfirmar,
    pedido
}) => {
    const [disabled, setDisabled] = useState<boolean>(false);


    return <div className="BoletoSolo">
        <HeaderFormaPagamento 
            icon={<><FaBarcode /></>}
            title={<>Boleto</>}
        />
        <Boleto
            disabled={true}
            valor={pedido?.valor_pendente}
            sizes={"X12 S6 M4"}
        />
        <div className="row">
            <div className="X12 S6 M4 L2 S--offset6 M--offset8 L--offset10">
                <FullWidthButton 
                    text="Confirmar"
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={() => {
                        if (pedido) {
                            const boleto: BoletoType = {
                                valor: pedido.valor_pendente,
                                valor_original: pedido.valor_pendente
                            }
        
                            const pedidoPagamento: PedidoPagamento = {
                                forma_pagamento: BOLETO.id,
                                pedido: pedido?.id,
                                itens: {
                                    boletos: [boleto]
                                }
                            }
                            onConfirmar(pedidoPagamento, BOLETO.id as any)
                            setDisabled(true)
                        }
                    }}
                />
            </div>
        </div>
    </div>
}

export { BoletoSolo }